// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addMinutes = convertToFP(fn, 2);
export default addMinutes;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addMinutes/index.js
// module id = 814
// module chunks = 0